import React from 'react'

import { string } from 'prop-types'

function ProfileHeader({ userPaymentMethod = '' }) {
  const subtitle = 'An overview of your sales, earnings, and subscription performance'

  return (
    <div className="sales-profile-header">
      <div className="content-heading">
        <h1 className="cgt-legacy-heading-h4">My Sales</h1>
        <p className="cgt-legacy-text-default cgt-mb-0">
          {subtitle}
        </p>
        <p className="profile-header-links cgt-mt-10">
          You can read here about{' '}
          <a
            href="https://help.cgtrader.com/hc/en-us/sections/360004406137-Getting-paid"
            target="_blank"
            rel="noreferrer"
          >
            Getting paid
          </a>{' '}
          or{' '}
          <a
            href="https://help.cgtrader.com/hc/en-us/sections/360004406117-Selling-and-promoting-models"
            target="_blank"
            rel="noreferrer"
          >
            Selling, and promoting models.
          </a>{' '}
          View the{' '}
          <a
            href="https://www.cgtrader.com/pages/earnings-and-payout-schedule"
            target="_blank"
            rel="noreferrer"
          >
            Earnings and Payout Schedule
          </a>.
        </p>
        {userPaymentMethod === 'hyperwallet' && (
          <p className="cgt-mt-10 profile-header-links">
            Go to{' '}
            <a
              href="https://cgtrader.payouts.hyperwallet.com"
              target="_blank"
              rel="noreferrer"
            >
              Hyperwallet Pay Portal
            </a>
          </p>
        )}
      </div>
    </div>
  )
}

ProfileHeader.propTypes = {
  userPaymentMethod: string,
}

export default ProfileHeader
